import React from 'react';
import { Link } from 'react-router-dom';
import { partners } from '../mock';
import { Phone, Mail, ArrowRight, Users } from 'lucide-react';
import { Button } from './ui/button';

const Partners = () => {
  return (
    <section id="partner" className="bg-[#eaf1f5] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <div className="inline-block">
            <div className="w-16 h-0.5 bg-[#b8893d] mx-auto mb-4"></div>
            <h2 className="font-serif font-light text-[#1B3A5C] text-4xl md:text-5xl tracking-[0.1em]">
              UNSERE PARTNER
            </h2>
            <div className="w-16 h-0.5 bg-[#b8893d] mx-auto mt-4"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-5xl mx-auto">
          {partners.map((p) => (
            <div
              key={p.name}
              className="group bg-white p-8 rounded-sm shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative overflow-hidden mb-6 mx-auto w-48 h-56 rounded-sm">
                <img
                  src={p.image}
                  alt={p.name}
                  style={{ objectPosition: p.objectPosition || 'center center' }}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1B3A5C]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              <div className="text-center">
                <h3 className="text-[#1B3A5C] font-semibold tracking-[0.1em] text-lg">{p.name}</h3>
                <p className="text-[#b8893d] text-xs tracking-[0.3em] mt-1 mb-4">{p.role}</p>
                <div className="w-12 h-px bg-[#b8893d]/40 mx-auto mb-4"></div>
                <div className="space-y-2">
                  <a
                    href={`tel:${p.phone}`}
                    className="flex items-center justify-center gap-2 text-[#34536b] text-sm hover:text-[#b8893d] transition-colors"
                  >
                    <Phone className="w-3.5 h-3.5" />
                    <span>{p.phone}</span>
                  </a>
                  <a
                    href={`mailto:${p.email}`}
                    className="flex items-center justify-center gap-2 text-[#34536b] text-sm hover:text-[#b8893d] transition-colors break-all"
                  >
                    <Mail className="w-3.5 h-3.5 flex-shrink-0" />
                    <span>{p.email}</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <Link to="/team">
            <Button variant="outline" className="border-[#1B3A5C] text-[#1B3A5C] hover:bg-[#1B3A5C] hover:text-white tracking-[0.15em] text-xs px-5 sm:px-8 py-6 bg-transparent max-w-full whitespace-normal h-auto">
              <Users className="mr-2 w-4 h-4" />
              GESAMTES TEAM KENNENLERNEN
              <ArrowRight className="ml-2 w-3.5 h-3.5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Partners;
